import { useEffect, useState } from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import branchApi from "../../services/branchApi";
import "../../assets/styles/users.scss";

const UsersFilters = ({ filters, onFilterChange, onSearch }) => {
    const [branches, setBranches] = useState([]);

    const normalizedBranches = Array.isArray(branches)
        ? branches
            .map((branch) => {
                if (!branch) return null;
                if (typeof branch === "string") {
                    return { id: branch, name: branch };
                }

                if (typeof branch === "object") {
                    return {
                        id: branch.id ?? branch.Id,
                        name: branch.name ?? branch.Name ?? String(branch.id ?? branch.Id ?? ""),
                    };
                }

                return null;
            })
            .filter((branch) => branch?.id != null)
        : [];

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                const list = await branchApi.getAllBranches(controller.signal);
                setBranches(Array.isArray(list) ? list : []);
            } catch (e) {
                setBranches([]);
            }
        })();

        return () => controller.abort();
    }, []);

    return (
        <Container fluid className="mt-4 w-100">
            <Form onSubmit={(e) => { e.preventDefault(); onSearch && onSearch(); }}>
                <Row className="mb-3 g-2 align-items-end flex-nowrap" style={{ overflowX: "auto" }}>
                    <Col md={2} style={{ minWidth: "200px" }}>
                        <Form.Group controlId="active">
                            <Form.Label>Aktywny</Form.Label>
                            <Form.Control
                                as="select"
                                value={filters.isActive ?? ""}
                                onChange={(e) => onFilterChange("isActive", e.target.value)}
                            >
                                <option value={null}>-- Wybierz --</option>
                                <option value={0}>NIE</option>
                                <option value={1}>TAK</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={2} style={{ minWidth: "200px" }}>
                        <Form.Group controlId="role">
                            <Form.Label>Rola</Form.Label>
                            <Form.Control
                                as="select"
                                value={filters.role || ""}
                                onChange={(e) => onFilterChange("role", e.target.value)}
                            >
                                <option value="">-- Wybierz --</option>
                                <option value="ROLE_USER">User</option>
                                <option value="ROLE_SUPERUSER">Power User</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={2} style={{ minWidth: "200px" }}>
                        <Form.Group controlId="branch">
                            <Form.Label>Oddział</Form.Label>
                            <Form.Control
                                as="select"
                                value={filters.branchId || ""}
                                onChange={(e) => onFilterChange("branchId", e.target.value)}
                            >
                                <option value="">-- Wybierz --</option>
                                {normalizedBranches.map((branch) => (
                                    <option key={branch.id} value={branch.id}>
                                        {branch.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={2} style={{ minWidth: "180px" }}>
                        <Form.Group controlId="search">
                            <Form.Label>Szukaj</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                value={filters.query || ""}
                                onChange={(e) => onFilterChange("query", e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
};

export default UsersFilters;